import { useQuery } from '@tanstack/react-query'
import { Select, Text } from '@viapeople/components'
import { useState } from 'react'
import { trpc } from '../../utils/trpc'
import { ManagerPdfsTab } from './ManagerPdfsTab'

export function ManagerPdfsPage() {
	const [selectedCycleId, setSelectedCycleId] = useState<string>('')

	const { data: cyclesData } = useQuery({
		...trpc.client.reports.getManagerCycles.queryOptions(),
	})

	const cycles = cyclesData || []
	const cycleOptions = cycles.map((c) => ({
		value: c.id,
		label: c.name || 'Cycle',
	}))

	return (
		<main data-testid='manager-pdfs-page' className='w-full p-6'>
			<div className='mb-6'>
				<Text data-testid='manager-pdfs-title' variant='h3' weight='semibold'>
					Manage PDFs
				</Text>
				<Text data-testid='manager-pdfs-subtitle' variant='small' className='text-neutral-600 mt-2'>
					Download individual or bulk PDFs for your team
				</Text>
			</div>

			<div className='mb-4'>
				<div className='min-w-[280px]'>
					<Select
						label='Cycle'
						placeholder={cycleOptions.length ? 'Select cycle' : 'No in-progress cycles'}
						options={cycleOptions}
						value={selectedCycleId}
						onChange={(value: string) => setSelectedCycleId(value)}
					/>
				</div>
			</div>

			<div className='border border-neutral-200 bg-neutral-0 rounded-lg shadow-sm'>
				<ManagerPdfsTab cycleId={selectedCycleId} />
			</div>
		</main>
	)
}
